if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this._submitting = false;

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.cartDrawer = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.note = document.querySelector('.note-product');
      if (this.note) {
        const textCounter = document.querySelector('.length-characters');
        if (textCounter) {
          const getMaxLength = parseInt(textCounter.dataset.length);
          this.note.addEventListener('input', () => {
            textCounter.innerHTML = getMaxLength - this.note.value.length;
          });
        }
      }

      this.variantSelects = document.querySelector('variant-selects');
      this.uploadArtworkCustomize = document.querySelector('upload-artwork-customize');
    }

    get uploadArtwork() {
      return this.closest(".loaded");
    }

    get submitting() {
      return this._submitting;
    }

    set submitting(value) {
      this._submitting = value;

      if (value) {
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-disabled', true);
      } else {
        this.submitButton.disabled = false;
        this.submitButton.removeAttribute('aria-disabled');
      }
    }

    async onSubmitHandler(e) {
      try {
        e.preventDefault();

        // if already submitting, stop the submit
        if (this.submitting) return;

        // set submitting to true
        this.submitting = true;

        // Refresh the variant select to get the latest values
        await this.variantSelects.onVariantChange();

        // if variant select is not valid, stop the submit
        if (!this.variantSelects.validInfo) return;

        // if variant select is valid, continue the submit
        const formData = new FormData(this.form);

        // Add the CSRF token to the form data
        formData.append('properties[_token]', Date.now());

        // Add the variant select properties to the form data
        let properties = null;
        if (this.variantSelects && this.variantSelects.properties) {
          properties = this.variantSelects.properties;
        }

        if (properties) {
          for (let key in properties) {
            if (['_customSize', 'SizeLabel'].includes(key) && formData.get(`properties[${key}]`) !== null) continue;

            formData.append(`properties[${key}]`, properties[key]);
          }
        }

        if (this.uploadArtwork) {
          if (this.uploadArtwork.status === 'uploading') return;

          if (this.uploadArtwork.uploaded.length > 0) {
            formData.append(
              'properties[_artwork]',
              this.uploadArtwork.uploaded.map((upload) => upload.secure_url),
            );
          }

          let designInstruction = '';
          if (!!this.uploadArtwork.instructions.some((instr) => !!instr.length)) {
            for (let i = 0; i < this.uploadArtwork.instructions.length; i++) {
              if (this.uploadArtwork.instructions[i].trim().length > 0) {
                designInstruction += `Image #${i + 1} (instructions) - ${this.uploadArtwork.instructions[i]} \n`;
              }
            }
          }

          if (this.note && this.note.value.length > 0) {
            designInstruction += `Notes instructions - ${this.note.value} \n`;
          }

          if (designInstruction.length > 0) {
            formData.append('properties[_designInstruction]', designInstruction);
          }
        }

        formData.append(
          'sections',
          this.cartDrawer.getSectionsToRender().map((section) => section.id),
        );
        formData.append('sections_url', window.location.pathname);
        formData.set('quantity', formData.get('quantity'));

        const response = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        }).then((res) => res.json());

        if (response.status) return;

        this.cartDrawer.renderContents(response);
        if (this.uploadArtwork && this.uploadArtworkCustomize) {

          const contentUploadArtwork = this.uploadArtworkCustomize.querySelector('.content');
          if (!contentUploadArtwork) return;
          const files = contentUploadArtwork.querySelectorAll('.item-file');
          files.forEach(file =>  file.remove());
          this.uploadArtworkCustomize.uploaded = [];
          this.uploadArtworkCustomize.instructions = [];
          this.uploadArtworkCustomize._status = 'not-started';
          this.uploadArtworkCustomize.index = -1;
          this.uploadArtworkCustomize.status = 'waiting';
          this.uploadArtworkCustomize.note.value = '';
          this.uploadArtworkCustomize.uploadInput.value = '';
        }

        this.trackAddtoCartEvent(response);
      } catch (error) {
        console.error(error);
      } finally {
        this.submitting = false;
      }
    }

    trackAddtoCartEvent(item) {
      try {
        if (typeof window.lintrk === 'function') window.lintrk('track', {conversion_id: 12984585});

        if (typeof klaviyo !== 'undefined' && klaviyo && window.customer) {
          klaviyo.identify({
            $email: window.customer.email,
            $first_name: window.customer.name,
          }, function() {
            klaviyo.track("Added to Cart", item);
          });
        }
      } catch (error) {
        console.log(error);
      }

      try {
        const productJSON = document.getElementById('product-json');
        if (productJSON) {
          const product = JSON.parse(productJSON.textContent);
          const variantId = parseInt(this.form.querySelector('[name=id]').value);
          const variant = product.variants.find(v => v.id === variantId) || product.variants[0];
          const quantity = parseInt(this.form.querySelector('[name=quantity]').value) || 1;

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'product_added_to_cart',
            ecommerce: {
              currencyCode: window.Shopify?.currency?.active || 'USD',
              add: {
                products: [{
                  id: String(variant.id),
                  name: product.title,
                  variant: variant.title !== 'Default Title' ? variant.title : undefined,
                  price: (variant.price / 100).toFixed(2),
                  quantity: quantity
                }]
              }
            }
          });
        }
      } catch (error) {
        console.log('GA4 add_to_cart event error:', error);
      }
    }
  }

  customElements.define('product-form', ProductForm);
}

if (!window.__addCartEventBound) {
  window.__addCartEventBound = true;
  const AddCartEvent = document.querySelector('.button.add-to-cart');
  if (AddCartEvent) {
    AddCartEvent.addEventListener('click', () => {
      if (typeof window.lintrk === 'function') window.lintrk('track', {conversion_id: 12984585});
    });
  }
}
